import {
    CHANGE_VCARD_STATUS,
    ChangeVCardStatus,
    CLEAR_VCARD,
    ClearVCard,
    CLOSE_VCARD_EDITOR,
    CloseVCardEditor,
    DECLINE_WARNING_TOOLTIP_VCARD_ADDRESS_FORM,
    DeclineWarningTooltipVCardAddressForm,
    ON_SET_WARNING_TOOLTIP_VCARD_ADDRESS_FORM,
    ON_UPDATE_VCARD_ADDRESS_FORM_BY_FIELD,
    OnSetWarningTooltipVCardAddressForm,
    OnUpdateVCardAddressFormByField,
    OPEN_VCARD_EDITOR,
    OpenVCardEditor,
    REMOVE_VCARD_ERROR,
    RemoveVCardErrors,
    RESET_VCARD,
    ResetVCard,
    SAVE_SUCCESS_FOR_EDITOR_VCARDS,
    SAVE_VCARDS,
    SaveSuccessForEditorVCards,
    SaveVCards,
    SHOW_WARNING_TOOLTIP_VCARD_ADDRESS_FORM,
    ShowWarningTooltipVCardAddressForm,
    TOGGLE_VCARD_NOT_SHOW_METRO_IN_SEARCH,
    TOGGLE_VCARD_SHORT_VERSION_FLAG,
    ToggleVCardNotShowMetroInSearchFlag,
    ToggleVCardShortVersionFlag,
    UPDATE_AND_OPEN_VCARD_FOR_EDIT,
    UPDATE_DRAFT_VCARD,
    UPDATE_PHONE_CODE_BY_REGION_ID_FOR_VCARD,
    UPDATE_SELF_CHOOSE_VCARD_MAP_POSITION,
    UPDATE_VCARD_ADDRESS_INPUT,
    UPDATE_VCARD_ADDRESS_MAP_POINT,
    UPDATE_VCARD_ADDRESS_SUGGEST,
    UPDATE_VCARD_GEO_OBJECT,
    UPDATE_VCARD_METRO_STATION_INFO,
    UPDATE_VCARDS_ERRORS,
    UPDATE_VISITING_CARD_ERRORS,
    UpdateAndOpenVCardForEdit,
    UpdateDraftVCard,
    UpdatePhoneCodeByRegionIdForVCard,
    UpdateSelfChooseVCardMapPosition,
    UpdateVCardAddressInput,
    UpdateVCardAddressMapPoint,
    UpdateVCardAddressSuggest,
    UpdateVCardGeoObject,
    UpdateVCardMetroStationInfo,
    UpdateVCardsErrors,
    UpdateVisitingCardsErrors,
    VisitingCardEditorAction
} from '../actions/visitingCardEditor';
import { AddressField, getAddressObject } from '../service/AddressHelper/AddressHelper';
import { VCardPhoneFields, VcardStatus } from '../typings/banners';
import { State } from '../typings/state';
import { VisitingCardEditorsState } from '../typings/VisitingCardEditor';

const openVcardEditor = (state: VisitingCardEditorsState, action: OpenVCardEditor): VisitingCardEditorsState => {
    const {
        savedValue: { info, ...otherParamsSavedValue },
        editorId,
        vCardId
    } = action;

    return {
        ...state,
        [editorId]: {
            ...state[editorId],
            ...otherParamsSavedValue,
            vCardStatus: VcardStatus.EDITING,
            vCardData: info,
            isOpen: true,
            vCardId
        }
    };
};

const closeVcardEditor = (state: VisitingCardEditorsState, action: CloseVCardEditor): VisitingCardEditorsState => {
    const { editorId } = action;

    return {
        ...state,
        [editorId]: {
            ...state[editorId],
            isOpen: false
        }
    };
};

const toggleVcardShortVersionFlag = (
    state: VisitingCardEditorsState,
    action: ToggleVCardShortVersionFlag
): VisitingCardEditorsState => {
    const { editorId } = action;
    const editor = state[editorId];

    return {
        ...state,
        [editorId]: {
            ...editor,
            isShortVersionChecked: !editor.isShortVersionChecked
        }
    };
};

const toggleVcardNotShowMetroInSearch = (
    state: VisitingCardEditorsState,
    action: ToggleVCardNotShowMetroInSearchFlag
): VisitingCardEditorsState => {
    const { editorId } = action;
    const editor = state[editorId];

    return {
        ...state,
        [editorId]: {
            ...editor,
            isNotShowMetroInSearchChecked: !editor.isNotShowMetroInSearchChecked
        }
    };
};

const updateDraftVcard = (state: VisitingCardEditorsState, action: UpdateDraftVCard): VisitingCardEditorsState => {
    const { editorId, vCard, vCardStatus = VcardStatus.EDITING } = action;
    const editor = state[editorId];

    return {
        ...state,
        [editorId]: {
            ...editor,
            vCardData: vCard,
            vCardStatus: vCardStatus
        }
    };
};

const resetVcard = (state: VisitingCardEditorsState, action: ResetVCard): VisitingCardEditorsState => {
    const {
        savedValue: { info, ...otherParamsSavedValue },
        editorId
    } = action;

    return {
        ...state,
        [editorId]: {
            ...state[editorId],
            ...otherParamsSavedValue,
            vCardData: info,
            isOpen: false,
            errors: undefined
        }
    };
};

const saveVcards = (state: VisitingCardEditorsState, action: SaveVCards): VisitingCardEditorsState => {
    const { editorId } = action;

    return {
        ...state,
        [editorId]: {
            ...state[editorId],
            vCardStatus: VcardStatus.PROGRESS
        }
    };
};

const updateVcardsErrors = (state: VisitingCardEditorsState, action: UpdateVCardsErrors): VisitingCardEditorsState => {
    const { editorIds, updateEditorIds, errors: errorsData } = action;

    return {
        ...state,
        ...editorIds.reduce((acc, editorId, index) => {
            if (updateEditorIds.includes(editorId)) {
                acc[editorId] = {
                    ...state[editorId],
                    errors: errorsData[index],
                    vCardStatus: VcardStatus.EDITING
                };
            } else {
                acc[editorId] = {
                    ...state[editorId],
                    isOpen: false,
                    vCardStatus: VcardStatus.EDITING
                };
            }

            return acc;
        }, {})
    };
};

const saveSuccessForEditorVCards = (
    state: VisitingCardEditorsState,
    action: SaveSuccessForEditorVCards
): VisitingCardEditorsState => {
    const { editorIds, vCardIds } = action;

    return {
        ...state,
        ...editorIds.reduce((acc, editorId, index) => {
            acc[editorId] = {
                ...state[editorId],
                isOpen: false,
                vCardStatus: VcardStatus.EDITING,
                errors: undefined,
                vCardId: vCardIds[index]
            };

            return acc;
        }, {})
    };
};

const clearVCard = (state: VisitingCardEditorsState, action: ClearVCard): VisitingCardEditorsState => {
    const { editorIds } = action;

    return {
        ...state,
        ...editorIds.reduce((acc, editorId) => {
            acc[editorId] = {
                ...state[editorId],
                isOpen: false,
                vCardStatus: VcardStatus.EDITING,
                vCardId: '',
                errors: undefined
            };

            return acc;
        }, {})
    };
};

const removeVcardError = (state: VisitingCardEditorsState, action: RemoveVCardErrors): VisitingCardEditorsState => {
    const { editorId, paths } = action;
    const errors = state[editorId].errors;

    if (!errors) {
        return state;
    }

    return {
        ...state,
        [editorId]: {
            ...state[editorId],
            errors: errors.filter(error => !error.path || !paths.includes(error.path))
        }
    };
};

const updateVCardMetroStationInfo = (
    state: VisitingCardEditorsState,
    action: UpdateVCardMetroStationInfo
): VisitingCardEditorsState => {
    const { editorId, metroStationId, metroStationName } = action;
    const vCardData = state[editorId].vCardData;

    if (!vCardData) {
        return state;
    }

    return {
        ...state,
        [editorId]: {
            ...state[editorId],
            vCardData: {
                ...vCardData,
                metroStationId,
                metroStationName
            }
        }
    };
};

const updateVisitingCardErrors = (
    state: VisitingCardEditorsState,
    action: UpdateVisitingCardsErrors
): VisitingCardEditorsState => {
    const { editorId, errors } = action;

    return {
        ...state,
        [editorId]: {
            ...state[editorId],
            errors
        }
    };
};

const updateAndOpenVCardForEdit = (
    state: VisitingCardEditorsState,
    action: UpdateAndOpenVCardForEdit
): VisitingCardEditorsState => {
    const { vCards } = action;
    const vCardsKeys = Object.keys(vCards);
    const newVCards = vCardsKeys.reduce((acc: VisitingCardEditorsState, id: string) => {
        acc[id] = {
            ...acc[id],
            isOpen: true,
            vCardData: vCards[id]
        };

        return acc;
    }, {});

    return {
        ...state,
        ...newVCards
    };
};

const updateVCardAddressInput = (
    state: VisitingCardEditorsState,
    action: UpdateVCardAddressInput
): VisitingCardEditorsState => {
    const { editorId } = action;
    const editor = state[editorId];
    const vCardData = editor.vCardData;

    if (!vCardData) {
        return state;
    }

    return {
        ...state,
        [editorId]: {
            ...state[editorId],
            vCardData: {
                ...vCardData,
                address: action.address
            },
            errors: editor.errors
                ? editor.errors.filter(item => item.path && !item.path.includes('address'))
                : undefined
        }
    };
};

const updateVCardAddressSuggest = (
    state: VisitingCardEditorsState,
    action: UpdateVCardAddressSuggest
): VisitingCardEditorsState => {
    const { editorId } = action;
    const vCardData = state[editorId].vCardData;

    if (!vCardData) {
        return state;
    }

    return {
        ...state,
        [editorId]: {
            ...state[editorId],
            vCardData: {
                ...vCardData,
                suggest: {
                    [action.field]: action.suggest
                }
            }
        }
    };
};

const updateVCardMapPoint = (
    state: VisitingCardEditorsState,
    action: UpdateVCardAddressMapPoint
): VisitingCardEditorsState => {
    const { editorId, geoId, geoObject, pointOnMap } = action;
    const editor = state[editorId];
    const vCardData = state[editorId].vCardData;

    if (!vCardData) {
        return state;
    }

    return {
        ...state,
        [editorId]: {
            ...editor,
            vCardData: {
                ...vCardData,
                pointOnMap,
                geoObject,
                geoId,
                isAddressChangeControlVisible: false,
                newGeoObject: undefined
            }
        }
    };
};

const setWarningTooltipVCardAddress = (
    state: VisitingCardEditorsState,
    action: OnSetWarningTooltipVCardAddressForm
): VisitingCardEditorsState => {
    const { editorId } = action;
    const editor = state[editorId];
    const vCardData = editor.vCardData;

    if (!vCardData) {
        return state;
    }

    const address = getAddressObject(vCardData.newGeoObject, AddressField.house);

    return {
        ...state,
        [editorId]: {
            ...state[editorId],
            vCardData: {
                ...vCardData,
                address,
                newGeoId: undefined,
                newGeoObject: undefined,
                geoId: vCardData.newGeoId || vCardData.geoId,
                geoObject: vCardData.newGeoObject,
                selfChooseGeoObject: undefined,
                isAddressChangeControlVisible: false
            },
            errors: editor.errors
                ? editor.errors.filter(item => item.path && !item.path.includes('address'))
                : undefined
        }
    };
};

const showWarningTooltipVCardAddress = (
    state: VisitingCardEditorsState,
    action: ShowWarningTooltipVCardAddressForm
): VisitingCardEditorsState => {
    const { editorId, newGeoObject, selfChooseGeoObject, pointOnMap, geoId } = action;
    const vCardData = state[editorId].vCardData;

    if (!vCardData) {
        return state;
    }

    return {
        ...state,
        [editorId]: {
            ...state[editorId],
            vCardData: {
                ...vCardData,
                newGeoId: geoId,
                newGeoObject: newGeoObject,
                selfChooseGeoObject,
                pointOnMap,
                isAddressChangeControlVisible: true
            }
        }
    };
};

const declineWarningTooltipVCardAddress = (
    state: VisitingCardEditorsState,
    action: DeclineWarningTooltipVCardAddressForm
): VisitingCardEditorsState => {
    const { editorId } = action;
    const vCardData = state[editorId].vCardData;

    if (!vCardData) {
        return state;
    }

    return {
        ...state,
        [editorId]: {
            ...state[editorId],
            vCardData: {
                ...vCardData,
                newGeoId: undefined,
                newGeoObject: undefined,
                isAddressChangeControlVisible: false
            }
        }
    };
};

const updateVCardGeoObject = (
    state: VisitingCardEditorsState,
    action: UpdateVCardGeoObject
): VisitingCardEditorsState => {
    const { editorId, geoObject, geoId } = action;
    const editor = state[editorId];
    const vCardData = editor.vCardData;
    const address = getAddressObject(geoObject, AddressField.house);

    if (!vCardData) {
        return state;
    }

    return {
        ...state,
        [editorId]: {
            ...editor,
            vCardData: {
                ...vCardData,
                geoObject,
                geoId,
                address
            },
            errors: editor.errors
                ? editor.errors.filter(item => item.path && !item.path.includes('address'))
                : undefined
        }
    };
};

const onUpdateVCardAddressForm = (
    state: VisitingCardEditorsState,
    action: OnUpdateVCardAddressFormByField
): VisitingCardEditorsState => {
    const { editorId } = action;
    const editor = state[editorId];
    const { vCardData } = editor;

    if (!vCardData) {
        return state;
    }

    return {
        ...state,
        [editorId]: {
            ...editor,
            vCardStatus: VcardStatus.DISABLED,
            vCardData: {
                ...vCardData,
                selfChooseGeoObject: undefined,
                metroStationId: null
            }
        }
    };
};

const changeVCardStatus = (state: VisitingCardEditorsState, action: ChangeVCardStatus): VisitingCardEditorsState => {
    const { editorId, vCardStatus } = action;

    return {
        ...state,
        [editorId]: {
            ...state[editorId],
            vCardStatus
        }
    };
};

const updateVCardSelfGeoObjectByPoints = (
    state: VisitingCardEditorsState,
    action: UpdateSelfChooseVCardMapPosition
): VisitingCardEditorsState => {
    const { editorId, selfChooseGeoObject } = action;
    const editor = state[editorId];
    const { vCardData } = editor;

    if (!vCardData) {
        return state;
    }

    return {
        ...state,
        [editorId]: {
            ...state[editorId],
            vCardData: {
                ...vCardData,
                selfChooseGeoObject
            }
        }
    };
};

const updateVCardPhoneCode = (
    state: VisitingCardEditorsState,
    action: UpdatePhoneCodeByRegionIdForVCard
): VisitingCardEditorsState => {
    const { code, codeType, editorId } = action;
    const editor = state[editorId];
    const { vCardData } = editor;

    if (!vCardData) {
        return state;
    }

    return {
        ...state,
        [editorId]: {
            ...editor,
            vCardData: {
                ...vCardData,
                phone: {
                    ...vCardData.phone,
                    codeCountry: codeType === VCardPhoneFields.codeCountry ? `+${code}` : vCardData.phone.codeCountry,
                    codeRegion: codeType === VCardPhoneFields.codeRegion ? String(code) : vCardData.phone.codeRegion
                }
            }
        }
    };
};

export function visitingCardEditor(
    state: VisitingCardEditorsState = {},
    action: VisitingCardEditorAction,
    fullState: State
): VisitingCardEditorsState {
    switch (action.type) {
        case OPEN_VCARD_EDITOR:
            return openVcardEditor(state, action);
        case CLOSE_VCARD_EDITOR:
            return closeVcardEditor(state, action);
        case TOGGLE_VCARD_SHORT_VERSION_FLAG:
            return toggleVcardShortVersionFlag(state, action);
        case TOGGLE_VCARD_NOT_SHOW_METRO_IN_SEARCH:
            return toggleVcardNotShowMetroInSearch(state, action);
        case UPDATE_DRAFT_VCARD:
            return updateDraftVcard(state, action);
        case RESET_VCARD:
            return resetVcard(state, action);
        case SAVE_VCARDS:
            return saveVcards(state, action);
        case UPDATE_VCARDS_ERRORS:
            return updateVcardsErrors(state, action);
        case SAVE_SUCCESS_FOR_EDITOR_VCARDS:
            return saveSuccessForEditorVCards(state, action);
        case CLEAR_VCARD:
            return clearVCard(state, action);
        case UPDATE_VCARD_METRO_STATION_INFO:
            return updateVCardMetroStationInfo(state, action);
        case REMOVE_VCARD_ERROR:
            return removeVcardError(state, action);
        case UPDATE_VISITING_CARD_ERRORS:
            return updateVisitingCardErrors(state, action);
        case UPDATE_VCARD_ADDRESS_INPUT:
            return updateVCardAddressInput(state, action);
        case UPDATE_VCARD_ADDRESS_SUGGEST:
            return updateVCardAddressSuggest(state, action);
        case UPDATE_VCARD_ADDRESS_MAP_POINT:
            return updateVCardMapPoint(state, action);
        case ON_SET_WARNING_TOOLTIP_VCARD_ADDRESS_FORM:
            return setWarningTooltipVCardAddress(state, action);
        case SHOW_WARNING_TOOLTIP_VCARD_ADDRESS_FORM:
            return showWarningTooltipVCardAddress(state, action);
        case DECLINE_WARNING_TOOLTIP_VCARD_ADDRESS_FORM:
            return declineWarningTooltipVCardAddress(state, action);
        case ON_UPDATE_VCARD_ADDRESS_FORM_BY_FIELD:
            return onUpdateVCardAddressForm(state, action);
        case UPDATE_VCARD_GEO_OBJECT:
            return updateVCardGeoObject(state, action);
        case CHANGE_VCARD_STATUS:
            return changeVCardStatus(state, action);
        case UPDATE_SELF_CHOOSE_VCARD_MAP_POSITION:
            return updateVCardSelfGeoObjectByPoints(state, action);
        case UPDATE_AND_OPEN_VCARD_FOR_EDIT:
            return updateAndOpenVCardForEdit(state, action);
        case UPDATE_PHONE_CODE_BY_REGION_ID_FOR_VCARD:
            return updateVCardPhoneCode(state, action);
        default:
            return state;
    }
}
